import './StatTiles.css';

export interface Stat {
  label: string;
  value: string;
  unit?: string;
  note?: string;
}

/**
 * Headline figures carry no plot, so they are deliberately not charts. Values
 * wear text tokens rather than a series colour.
 */
export function StatTiles({ stats }: { stats: Stat[] }) {
  return (
    <div className="StatTiles">
      {stats.map((s) => (
        <div className="StatTiles-tile" key={s.label}>
          <div className="StatTiles-label">{s.label}</div>
          <div className="StatTiles-value">
            {s.value}
            {s.unit && <span className="StatTiles-unit">{s.unit}</span>}
          </div>
          {s.note && <div className="StatTiles-note">{s.note}</div>}
        </div>
      ))}
    </div>
  );
}
